module.exports = __webpack_public_path__ + "img/People oriented planning.335f9b8f.jpg";